import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.QualityCheckCard.title',
    defaultMessage: 'Every voice is professionally quality-checked',
  },

  creativeChecked: {
    id: 'components.QualityCheckCard.creativeChecked',
    defaultMessage: 'Creative review',
  },
  creativeCheckedDescription: {
    id: 'components.QualityCheckCard.creativeCheckedDescription',
    defaultMessage: 'We assess each artist’s strengths to ensure the right voice for your project.',
  },

  qualityChecked: {
    id: 'components.QualityCheckCard.qualityChecked',
    defaultMessage: 'Audio quality control',
  },
  qualityCheckedDescription: {
    id: 'components.QualityCheckCard.qualityCheckedDescription',
    defaultMessage: 'All recordings meet professional sound and technical standards.',
  },

  nativeChecked: {
    id: 'components.QualityCheckCard.nativeChecked',
    defaultMessage: 'Native language verification',
  },
  nativeCheckedDescription: {
    id: 'components.QualityCheckCard.nativeCheckedDescription',
    defaultMessage: 'We verify native fluency for natural delivery and authentic tone.',
  },
})
